import {UAMF_WS_KEEP_ALIVE_INTERVAL, UAMF_WS_PING_MESSAGE} from '../../consts/uamf/uamfWebSocketValues';
import DamWebSocketKeepAliveManager from '../dam/DamWebSocketKeepAliveManager';

export default class UamfWebSocketKeepAliveManager extends DamWebSocketKeepAliveManager {
    constructor({client, assetId, onError}) {
        super({
            client,
            assetId,
            onError,
            logPrefix: 'uamfWebSocketKeepAliveManager',
            keepAliveInterval: UAMF_WS_KEEP_ALIVE_INTERVAL,
            keepAliveMessage: UAMF_WS_PING_MESSAGE,
        });
        this.isPingSent = false;
    }

    stop() {
        super.stop();
        this.isPingSent = false;
    }

    onPongReceived() {
        this.isPingSent = false;
    }

    sendKeepAliveMessage() {
        if (this.isPingSent) {
            this.onError();
            return;
        }

        this.isPingSent = true;

        try {
            if (!this.client) return;
            this.client.send(this.keepAliveMessage);
        } catch (e) {
            this.onError();
        }
    }
}
